import React from 'react';
import WalletConnector from '../WalletConnector';
import { useWeb3 } from '../../contexts/Web3Context';
import { useUI } from '../../contexts/UIContext';

const WalletConnectButton = () => {
  const { handleWalletConnect, handleWalletDisconnect } = useWeb3();
  const { showModal, setNetworkError } = useUI();
  
  // Handle chain change
  const handleChainChanged = (chainId) => {
    // opBNB  is 5611
    if (chainId !== 204) {
      setNetworkError(true);
      showModal(
        'Wrong Network', 
        'Please switch to opBNB  in your wallet to use this application.'
      );
    } else {
      setNetworkError(false);
    }
  };

  // Handle error from wallet
  const handleWalletError = (error) => {
    showModal('Connection Error', error || 'Failed to connect wallet. Please try again.');
  };

  return (
    <WalletConnector 
      onConnect={(address, provider, walletType) => {
        handleWalletConnect(address, provider, walletType);
      }}
      onDisconnect={handleWalletDisconnect}
      onChainChanged={handleChainChanged}
      onError={handleWalletError}
      requiredChainId={204} // opBNB 
      buttonClassName="connect-btn"
    />
  );
};

export default WalletConnectButton;